module.exports = __webpack_public_path__ + "img/vat-icon.aa33f96b.svg";